import React, { useEffect } from 'react';
import { renderRoutes, RouteConfigComponentProps } from 'react-router-config';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { offeringPoolListThunk } from 'store/reducers/temple/offeringPoolSlice';
import { selectCurrentTempleId } from 'store/reducers/temple/templeSlice';

const Offering: React.FC<RouteConfigComponentProps> = ({ route }) => {
    const dispatch = useAppDispatch()
    const currentTempleId = useAppSelector(selectCurrentTempleId)

    useEffect(() => {
        if (currentTempleId) {
            dispatch(offeringPoolListThunk({ templeId: currentTempleId }))
        }
    }, [currentTempleId, dispatch])

    return renderRoutes(route?.routes)
}

export default Offering;
